// @flow

import { RestClientAuthenticated } from '../network';
import { turanBaseURL } from '../../utils/urlUtils';

const businessPlansApi = {
  fetchAllByPcId: (pcId: number) => new RestClientAuthenticated(`${turanBaseURL()}/business-plans/${pcId}`, 'GET').execute(),
};

export default businessPlansApi;
